var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.isSending)?_c('b-notification',{attrs:{"closable":false,"type":"is-info"}},[_vm._t("default",[_vm._v("Saving...")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }